export const USER_GENDERS = ["female", "male", "nonbinary"] as const;

export type UserGender = (typeof USER_GENDERS)[number];

export const USER_GENDER_LABELS: Record<UserGender, string> = {
  female: "여성",
  male: "남성",
  nonbinary: "논바이너리/그 외",
};

export const USER_GENDER_LABELS_EN: Record<UserGender, string> = {
  female: "Female",
  male: "Male",
  nonbinary: "Non-binary / other",
};

const USER_GENDER_SET = new Set<string>(USER_GENDERS);

export function normalizeUserGender(value: unknown): UserGender | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim().toLowerCase();
  if (!normalized) return null;

  if (USER_GENDER_SET.has(normalized)) {
    return normalized as UserGender;
  }
  if (["f", "female", "woman", "women", "여", "여성", "여자"].includes(normalized)) {
    return "female";
  }
  if (["m", "male", "man", "men", "남", "남성", "남자"].includes(normalized)) {
    return "male";
  }
  if (
    [
      "non-binary",
      "nonbinary",
      "nb",
      "other",
      "others",
      "그외",
      "그 외",
      "기타",
      "논바이너리",
    ].includes(normalized)
  ) {
    return "nonbinary";
  }
  return null;
}

export function isOptionalUserGenderInput(value: unknown): boolean {
  if (value === undefined || value === null) return true;
  if (typeof value !== "string") return false;
  return value.trim() === "" || normalizeUserGender(value) !== null;
}
